import type { UIEvent, HTMLButtonElement } from 'react';

export enum OVERLAY_CONST {
  TEST_ID = 'overlay',
}

export type OverlayProps = {
  visible: boolean;
  onClick: (event: UIEvent<HTMLButtonElement>) => void;
  isExtendedCaptation?: boolean;
};
